enum ActionType {
  GET_IMAGES = "GET_IMAGES",
  GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS",
  GET_IMAGES_FAIL = "GET_IMAGES_FAIL",
  DELETE_IMAGES = "DELETE_IMAGES",
  SEARCH_IMAGES = "SEARCH_IMAGES",
  CHECK_IMAGE = "CHECK_IMAGE",
  SORT_BY_TITLE = "SORT_BY_TITLE",
  SORT_BY_DATE = "SORT_BY_DATE",
  SORT_BY_SIZE = "SORT_BY_SIZE",
  DELETE_CHECKED_IMAGE = "DELETE_CHECKED_IMAGE",
  REMOVE_CHECKS = "REMOVE_CHECKS",
  GET_SEARCH_IMAGES = "GET_SEARCH_IMAGES",
  SELECT_IMAGE_TO_ADD = "SELECT_IMAGE_TO_ADD",
  ADD_NEW_IMAGE = "ADD_NEW_IMAGE",
}

export default ActionType;
